module.exports = __webpack_public_path__ + "static/intro_bg-38d70e526da14fe8391a2023de29ce9e.png";